module.exports = __webpack_public_path__ + "img/instagram.bc37cc90.png";